import SortingButton from 'components/actions/SortingButton';
import { memo, useState } from 'react';

import DeviationListSpinner from './DeviationListSpinner';
import EmptyDeviationList from './EmptyDeviationList';
import PrioritizedItemsGroup from './PrioritizedItemsGroup';
import styles from './styles/components.module.scss';
import type { PrioritezedItem } from './types';

export type SortingByT = 'byOldest' | 'byNewest';

interface Props {
    inMRM?: PrioritezedItem[];
    others?: PrioritezedItem[];
    isLoading: boolean;
}

const PrioritizedVehicleList = ({ inMRM, others, isLoading }: Props) => {
    const inMrmTotal = inMRM?.length ? inMRM.length : 0;
    const othersTotal = others?.length ? others.length : 0;
    const cardsCounter = inMrmTotal + othersTotal;
    const [sortingBy, handleSortingBy] = useState<SortingByT>('byOldest');

    const sortByNewest = () => {
        handleSortingBy('byNewest');
    };

    const sortByOldest = () => {
        handleSortingBy('byOldest');
    };

    if (isLoading) {
        return <DeviationListSpinner />;
    }

    if (!isLoading && !inMRM && !others) {
        return <EmptyDeviationList />;
    }

    return (
        <>
            <header className={`${styles['mb-24']} display-flex align-items-center justify-content-between`}>
                <h2 className={`${styles['header-2']}`}>
                    Priority vehicles
                    <span className={`${styles['cards-counter']}`}>{cardsCounter}</span>
                </h2>
                <SortingButton sort={sortByNewest} unsort={sortByOldest} />
            </header>
            <PrioritizedItemsGroup items={inMRM} sortingBy={sortingBy} />
            <PrioritizedItemsGroup items={others} sortingBy={sortingBy} />
        </>
    );
};

export default memo(PrioritizedVehicleList);
